export default "__VITE_ASSET__5c53005f__"